import useAppToast from '@/hooks/useAppToast';
import { restoreDeleteClinic } from '@/services/admin/deleteClinicService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useRestoreDeleteClinic = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (id: number) => restoreDeleteClinic(currentSite, id),
    meta: { suppressNotFoundToast: true },
    onSuccess: async () => {
      toast.success('復元しました。');
      await queryClient.invalidateQueries({ queryKey: ['delete-clinics', currentSite] });
    },
    onError: () => {
      toast.error('復元できませんでした。');
    },
  });

  return { restoreClinic: mutateAsync, isPending };
};
